import * as Icons from '@ant-design/icons';
import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, Switch } from 'antd';

const { TextArea } = Input;
const { Option } = Select;

const generateApiName = (label) => {
  return label
    .replace(/[^a-zA-Z]/g, '') // keep only letters
    .replace(/\s+/g, '')       // remove spaces
    .trim();
};

const CreateAppModal = ({ open, onCancel, onSave, editingApp }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (editingApp) {
      form.setFieldsValue(editingApp);
    } else {
      form.resetFields();
    }
  }, [editingApp, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      onSave(values);
    } catch (err) {
      console.error('Validation Failed:', err);
    }
  };

  // called when user leaves label field
  const handleLabelChange = () => {
    if (!editingApp) {
      const label = form.getFieldValue("label") || "";
      const apiName = generateApiName(label);
      form.setFieldsValue({ name: apiName });
    }
  };

  // prepare icon options (filtering A–T icons only, can expand later)
  const iconOptions = Object.keys(Icons)
    .filter((iconName) => iconName[0] >= 'A' && iconName[0] <= 'T')
    .map((iconName) => {
      const IconComponent = Icons[iconName];
      return (
        <Option key={iconName} value={iconName} label={iconName}>
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {React.createElement(IconComponent, { style: { marginRight: 8 } })}
            {iconName}
          </span>
        </Option>
      );
    });

  return (
    <Modal
      title={editingApp ? 'Edit App' : 'Create App'}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      okText="Save"
      cancelText="Cancel"
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="label"
          label="Label"
          rules={[{ required: true, message: 'Please enter label' }]}
        >
          <Input onBlur={handleLabelChange} />
        </Form.Item>

        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'Please enter name' }]}
        >
          <Input disabled={!!editingApp} />
        </Form.Item>

        <Form.Item name="description" label="Description">
          <TextArea rows={3} />
        </Form.Item>

        <Form.Item
          name="type"
          label="Type"
          rules={[{ required: true, message: 'Please select type' }]}
        >
          <Select>
            <Select.Option value="custom">Custom</Select.Option>
            <Select.Option value="standard">Standard</Select.Option>
          </Select>
        </Form.Item>

        <Form.Item name="component" label="Component">
          <Input />
        </Form.Item>

        <Form.Item name="icon" label="Icon">
          <Select
            showSearch
            allowClear
            placeholder="Select an icon"
            optionLabelProp="label"
          >
            {iconOptions}
          </Select>
        </Form.Item>

        <Form.Item name="active" label="Active" valuePropName="checked">
          <Switch />
        </Form.Item>

        <Form.Item name="default" label="Default" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default CreateAppModal;
